// components/FormSelect
import React from "react";
import Select from "react-select";
import { Controller, Control } from "react-hook-form";

export type OptionType = {
  value: number | string;
  label: string;
};

type FormSelectProps = {
  name: string;
  control: Control<any>;
  options: OptionType[];
  placeholder?: string;
  isClearable?: boolean;
  isMobile?: boolean;
  onChange?: (opt?: OptionType) => void;
};

const FormSelect: React.FC<FormSelectProps> = ({
  name,
  control,
  options,
  placeholder = "Chọn...",
  isClearable = true,
  isMobile = false,
  onChange,
}) => {
  const ClearIndicator = () => null;
  const DropdownIndicator = () => null;
  const IndicatorSeparator = () => null;

  const customComponents = {
    ClearIndicator,
    DropdownIndicator,
    IndicatorSeparator,
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const valueNum =
          typeof field.value === "string"
            ? isNaN(Number(field.value))
              ? field.value
              : Number(field.value)
            : field.value ?? null;

        const selected = options.find((o) => o.value === valueNum) ?? null;

        return (
          <Select
            {...field}
            components={isMobile ? customComponents : undefined}
            options={options}
            placeholder={placeholder}
            isClearable={isClearable}
            onChange={(selected) => {
              field.onChange(selected?.value ?? null);
              onChange?.(selected || undefined);
            }}
            value={selected}
            classNamePrefix="react-select"
            classNames={{
              placeholder: () => "truncate whitespace-nowrap overflow-hidden input-font",
              option: () => "input-font",
              input: () => "input-font",
              singleValue: () => "input-font"
            }}
            theme={(theme) => ({
              ...theme,
              borderRadius: 4,
              colors: {
                ...theme.colors,
                primary: "#16A34A",
              },
            })}
            menuPosition="fixed"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        );
      }}
    />
  );
};

export default FormSelect;
